import styled from "styled-components";
import { Form, Table } from "react-bootstrap";

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        text-align: center;
        background-color: rgb(221, 221, 221);
        border: 1px solid white !important;
        font-size: 12px;
    }

    & > thead > tr > th a {
        cursor: default;
    }

    thead th:first-child {
        border-radius: 4px 0 0 0px;
    }

    thead th:last-child { 
        border-radius: 0 4px 0px 0;
    }

    & > tbody > tr:first-child > td,
    & > tbody > tr:first-child > th {
        border-top: none;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
        font-size: 12px;
    }

    & > tbody > tr > td:first-child {
        // text-align: left;
    }

    & > tbody > tr:nth-of-type(odd) > td.alternate-stripe {
        background-color: #ddeeff !important;
    }

    & > tbody > tr:nth-of-type(even) > td.alternate-stripe {
        background-color: #eef9ff !important;
    }

    & > thead > tr:first-child > th {
        height: 30px;
        white-space: nowrap;
        width: 35px;
        background-color: rgb(40,96,144);
        border:none;
        color:#FFF;
    }

    & > thead > tr > th:first-child {
        width:auto;
    }

    & > thead > tr > th > div {
        text-align: left !important;
        transform: translate(30px, -1px) rotate(315deg);
        width: 35px;
        padding-left: 5px
    }

    & > thead > tr > th > div > span {
        display: block;
        border-bottom: 1px solid #CCC;
        width: 200px;
    }

    & tfoot > tr {
        text-align: center;
        background-color:rgb(131,175,221);
    }

    .compare-conversion-row:hover {
        background-color: yellow;
    }
`;

export const ReportWrapper = styled.div`
    width: 100%;
    height: ${p => p.height ? p.height : '62vh'};

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-cell::after {
        //border-right: 1px solid #ccc;
        content: " ";
        height: 16px;
        margin-top: 4px;
        position: absolute;
        text-indent: -2000px;
        top: 0;
        right: 0;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-floating-top {
        overflow: hidden !important;
    }

    .ag-row {
        z-index: 0;
    }

        .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-header-group-cell-label {
        justify-content: center;
    }

    .ag-header-group-text {
        color: yellow;
    }

    .list-group-header {
        //background-color: #F6CC9F;
        color: #fff;
        display: flex;
        justify-content: center;
        // align-items: flex-end;
        border-color: #eee;
        // border-left-width: 0px;
        // border-right-width: 1px;
        border-width: 0px 1px 0px 0px;
        border-style: solid;
        // font-weight: 500;
    }

    .list-header {
        background-color: rgb(221, 221, 221);;
        color: rgb(51, 122, 183);
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        // font-weight: 600;
        padding-bottom: 5px;
    }

    .list-header-no-padding {
        background-color: rgb(221, 221, 221);;
        color: rgb(51, 122, 183);
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 600;
        padding: 0px 0px 5px 3px;
        margin: 0;
    }

    .list-cell {
        //background-color: #F6CC9F;
        //color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #eee;
    }

    .list-cell-no-padding {
        padding: 4px 0px 0px 0px;
        margin: 0;
        display: flex;
        justify-content: center;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .ag-icon.ag-icon-expanded {
        color: white;
    }

    .ag-icon.ag-icon-contracted {
        color: white;
    }

    .customHeaderLabel {
        // margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    .nkr-highlighted {
        background-color: yellow;
    }

    .sort-at-bottom {
        text-align: center;
        line-height: 1;
    }

    .sort-at-bottom > .customHeaderLabel {
        float: none;
        line-height: 1;
    }

    /* Define styles for alternating odd and even rows */

    .alternate-stripe {
        background-color: #ddeeff; /* Odd row color */
    }

    .even-stripe {
        background-color: #eef9ff; /* Even row color */
    }
`;

export const FormWrapper = styled(Form)`
    .form-group {
        margin-bottom: 5px;
    }
`;